import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-north-dakota-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./north-dakota-state-form.component.html",
  styleUrl: "./north-dakota-state-form.component.scss",
})
export class NorthDakotaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
